import { render, staticRenderFns } from "./PlansListSort.vue?vue&type=template&id=385227ba"
import script from "./PlansListSort.vue?vue&type=script&lang=js"
export * from "./PlansListSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports